import { daysOfWeek } from '../week'

export const listOfDays = ({ gov_record = {} }) => {
  if (gov_record.ListOfDays && gov_record.ListOfDays.Day) {
    return gov_record.ListOfDays.Day
  }

  return []
}

export const days = record => {
  const list = listOfDays(record).map(({ DayOfCare }) => String(DayOfCare).toLowerCase())

  // This is so we can present the list of days in cronological order
  // As the in the gov_record the days are grouped by the enrolment,
  // so days can be out of order
  return daysOfWeek
    .filter(({ label }) => list.includes(String(label).toLowerCase()))
    .map(({ label }) => label)
}

export const activeCase = ({ gov_record }) =>
  [
    'approved',
    'pending',
    'ready for approval',
    'started',
    'submit for approval',
    'submit for endorsement',
    'varied',
    'waitlisted',
  ].includes(String(gov_record.Status).toLowerCase())



// WEBPACK FOOTER //
// ./src/iss-case-claims/helpers.js